import { FormProvider, Stack, Alert } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { MultipleEquityInfoDocument } from './MultipleEquityInfoDocument';
import { useEquityInfo } from './hooks/useEquityInfoForm';
import { CompanyEquityInformationSerializer } from '@bcba/serializers';
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';

interface Props {
  data: CompanyEquityInformationSerializer;
  refetch: (
    options?: RefetchOptions | undefined,
  ) => Promise<QueryObserverResult<CompanyEquityInformationSerializer, Error>>;
}

export const EquityInfoForm = ({ data, refetch }: Props) => {
  const { t } = useTranslation();
  const {
    isPendingChangeRequest,
    validationMessage,
    handleSubmit,
    formMethods,
    handleSave,
    actionButtons,
    isFormReadOnly,
  } = useEquityInfo(data, refetch);

  return (
    <form onSubmit={handleSubmit(handleSave)}>
      <FormProvider {...formMethods}>
        <Stack gap={8}>
          {isPendingChangeRequest && validationMessage && (
            <Alert
              title={t('explorer.changeRequest.alert.title')}
              description={validationMessage}
              variant="error"
            />
          )}

          <MultipleEquityInfoDocument
            name="balanceDocuments"
            label={t('common.equityInformation.balance.title')}
            additionalLabel={t('common.equityInformation.add.balance')}
            disabledActions={isFormReadOnly}
            hideDelete={isFormReadOnly}
          />
          <MultipleEquityInfoDocument
            name="additionalDocuments"
            label={t('common.equityInformation.additionalDocument.title')}
            additionalLabel={t(
              'common.equityInformation.add.additionalDocument',
            )}
            disabledActions={isFormReadOnly}
            hideDelete={isFormReadOnly}
          />

          {actionButtons}
        </Stack>
      </FormProvider>
    </form>
  );
};

export default EquityInfoForm;
